import { createTRPCContext } from "@trpc/tanstack-react-query";
import type { RootRouter } from "@project/api";

export const { TRPCProvider, useTRPC, useTRPCClient } = createTRPCContext<RootRouter>();
